import AnalisaBarangJadiRAB from "./AnalisaBarangJadi"

export default AnalisaBarangJadiRAB